import { toISODate } from "../../../../utils/date";

/**
 * Calcula o range de datas a partir de um preset de filtro.
 */
export const getDateRange = (filter) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (filter) {
        case "TODAY": {
            return { startDate: toISODate(today), endDate: toISODate(today) };
        }
        case "WEEK": {
            const weekStart = new Date(today);
            const dayOfWeek = weekStart.getDay();
            const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            weekStart.setDate(weekStart.getDate() - diff);
            return { startDate: toISODate(weekStart), endDate: toISODate(today) };
        }
        case "MONTH": {
            const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            return { startDate: toISODate(monthStart), endDate: toISODate(today) };
        }
        case "ALL":
        default:
            return { startDate: null, endDate: null };
    }
};
